import { makeAutoObservable } from 'mobx';

class Store {
	open = false;

	constructor() {
		makeAutoObservable(this);
	}

	setOpen = (value: boolean): void => {
		this.open = value;
	};
}

export const store = new Store();
